import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('downloadable')

export default function Downloadable({ children }) {
  return (
    <div {...bem('')}>
       {children} 
    </div>
  )
}

Downloadable.propTypes = {
  children: T.any.isRequired,
}
